/**
 * Lightweight analytics event tracker for funnel drop-off tracking.
 * Events are sent to the backend and logged for analysis.
 */

const API = process.env.REACT_APP_BACKEND_URL;

const EVENTS = {
  // Funnel events
  LANDING_VIEW: 'landing_view',
  SIGNUP_STARTED: 'signup_started',
  SIGNUP_COMPLETED: 'signup_completed',
  EMAIL_VERIFIED: 'email_verified',
  LOGIN: 'login',
  CV_UPLOAD_STARTED: 'cv_upload_started',
  CV_UPLOAD_COMPLETED: 'cv_upload_completed',
  COVER_LETTER_GENERATED: 'cover_letter_generated',
  CV_OPTIMIZED: 'cv_optimized',
  APPLY_CLICKED: 'apply_clicked',
  APPLICATION_SUBMITTED: 'application_submitted',
  PRICING_VIEWED: 'pricing_viewed',
  TRIAL_STARTED: 'trial_started',
  CHECKOUT_STARTED: 'checkout_started',
  CHECKOUT_COMPLETED: 'checkout_completed',
  SUBSCRIPTION_UPGRADED: 'subscription_upgraded',
  CREDITS_PURCHASED: 'credits_purchased',
  SWIPES_PURCHASED: 'swipes_purchased',
  // Feature events
  SWIPE_MODE_STARTED: 'swipe_mode_started',
  SWIPE_RIGHT: 'swipe_right',
  SWIPE_LEFT: 'swipe_left',
  JOB_SAVED: 'job_saved',
  INTERVIEW_PREP_STARTED: 'interview_prep_started',
  JOB_FEED_SEARCH: 'job_feed_search',
};

/**
 * Track an analytics event. Fire-and-forget — never blocks the UI.
 * @param {string} event - Event name from EVENTS
 * @param {object} properties - Optional event properties
 */
function track(event, properties = {}) {
  try {
    const token = localStorage.getItem('token');
    const payload = {
      event,
      properties,
      timestamp: new Date().toISOString(),
      page: window.location.pathname,
    };
    // Fire-and-forget fetch — don't await, don't block
    fetch(`${API}/api/analytics/event`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(payload),
    }).catch(() => {}); // Silently ignore failures
  } catch {
    // Never let analytics break the app
  }
}

export { EVENTS, track };
